<script>
import { onMounted } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

onMounted(async () => {
    await store.dispatch('auth/getUserInfo');
});

export default {};
</script>

<template>
  <div class="success-container">
    <div class="card">
      <h2 class="title">Оплата успешно получена</h2>
      <p class="desc">
        Спасибо! Подписка активирована. Вы можете продолжить работу в системе.
      </p>

      <el-button
        type="primary"
        size="large"
        class="btn"
        @click="$router.push('/')"
      >
        Перейти в личный кабинет
      </el-button>

      <el-button
        type="default"
        size="large"
        class="btn mt-2"
        @click="$router.push('/billing')"
      >
        Перейти к управлению подпиской
      </el-button>
    </div>
  </div>
</template>

<style scoped>
.success-container {
  width: 100%;
  min-height: 70vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.card {
  background: #ffffff;
  padding: 40px 50px;
  border-radius: 12px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.1);
  text-align: center;
  max-width: 420px;
  width: 100%;
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: #16a34a;
  margin-bottom: 15px;
}

.desc {
  font-size: 16px;
  color: #374151;
  margin-bottom: 30px;
}

.btn {
  width: 100%;
}
</style>
